/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */
import { Component } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import * as fromRoot from '@api/store/app-store';
import { User } from '@api/models/user';

declare var global: any;

@Component({
    selector: 'main-header',
    template: require('./header.component.html')
})
export class HeaderComponent {
    selectedImage: string = "../../../assets/svg/logo_Barclays.svg";
    user$: Observable<User>;

    constructor(private store: Store<fromRoot.AppState>) {
        this.user$ = store.select(fromRoot.getUser);
    }

    public changeTheme(colour: string) {
        global['document'].getElementsByTagName('body')[0].className = "theme-" + colour;
        this.selectedImage = colour == 'blue' ? "../../../assets/svg/logo_Barclays.svg" : "../../../assets/svg/logo_absa_grey.svg";
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/components/header/header.component.ts